export default __webpack_public_path__ + "static/media/mobile1.6b0f2498.webp";